<div class="left_block" *ngIf="!IsReverse">

  <button class="btn_del" (click)="this.deleteClicked.emit()" title="{{'Delete'|translate}}"></button>

  <button class="btn_userright" (click)="this.setOwnerClicked.emit()">{{'Change owner'|translate}}</button>

  <button class="btn_userright" *ngIf="!IsCopyControl" (click)="this.shareClicked.emit()">{{'Share objects'|translate}}</button>
  <button class="btn_userright" *ngIf="IsCopyControl" (click)="this.shareClicked.emit()">{{'Copy'|translate}}</button>

  <div></div>
</div>

<div class="right_block" *ngIf="IsReverse">
  <button class="btn_del" (click)="this.deleteClicked.emit()" title="{{'Delete'|translate}}"></button>

  <button  class="btn_userleft" (click)="this.setOwnerClicked.emit()">{{'Change owner'|translate}}</button>

  <button *ngIf="!IsCopyControl" class="btn_userleft" (click)="this.shareClicked.emit()">{{'Share objects'|translate}}</button>
  <button *ngIf="IsCopyControl" class="btn_userleft"  (click)="this.shareClicked.emit()">{{'Copy'|translate}}</button>
</div>
